'use strict';


const rest = require('rest');
const defaultRequest = require('rest/interceptor/defaultRequest');
const timeout = require('rest/interceptor/timeout');
const mime = require('rest/interceptor/mime');
const params = require('rest/interceptor/params');
//import uriTemplateInterceptor from './api/uriTemplateInterceptor';
const errorCode = require('rest/interceptor/errorCode');
const baseRegistry = require('rest/mime/registry');

const interceptor = require('rest/interceptor');
const when = require('when');

const registry = baseRegistry.child();

registry.register('text/uri-list', require('./interceptors/uriListConverter'));
registry.register('application/hal+json', require('rest/mime/type/application/hal'));

const acceptOnly2xx = interceptor({
    response: function (response, config) {
        if (!response || !response.status || response.status.code < 200 || response.status.code > 299) return when.reject(response);
        return response;
    }
});

export default rest
    .wrap(mime, { registry: registry })
    .wrap(params)
    //.wrap(uriTemplateInterceptor)
    //.wrap(errorCode, { code: 500 }) // <- Reject only status codes 500+
    .wrap(acceptOnly2xx)
    .wrap(timeout, {timeout: 2 * 60 * 1000})
    .wrap(defaultRequest, { headers: { 'Accept': 'application/hal+json' }});



// WEBPACK FOOTER //
// ./src/client/src/utils/ajax/client.js